import StyledButton, { ButtonStyle, ButtonSize } from "../styled-button";
import { getPathPrefix } from "utils/getPathPrefix";

interface UpgradeCTAProps {
  onClick: () => void;
}

export default function UpgradeCTA({ onClick }: UpgradeCTAProps) {
  return (
    <StyledButton
      icon={getPathPrefix("/images/crown-gold.svg")}
      title={"Try Canvas Pro"}
      size={ButtonSize.regular}
      customStyle={{
        height: "30px",
        minWidth: "fit-content",
        fontWeight: "400",
        fontFamily: "Poppins",
        borderRadius: "6px",
      }}
      style={ButtonStyle.outline}
      onClick={onClick}
    />
  );
}
